import Swiper, { Pagination, Manipulation } from "swiper";
import { initIntersectionObserver } from "@plugins";

const instructionsSlider = document.querySelector(".js-instructions-slider");

if (window.mobileMedia && instructionsSlider) {
    initIntersectionObserver(instructionsSlider, initInstructionsSlider);
}

function initInstructionsSlider(slider) {
    const swiperContainer = slider.querySelector(".swiper");

    if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, {
            modules: [Pagination, Manipulation],
            speed: 400,
            spaceBetween: 16,
            slidesPerView: 1.1,
            breakpoints: {
                400: {
                    slidesPerView: 1.2,
                },
                425: {
                    slidesPerView: 1.3,
                },
                450: {
                    slidesPerView: 1.4,
                },
                567: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
            },
            pagination: {
                el: ".js-instructions-controls > .swiper-pagination",
                dynamicBullets: true,
                dynamicMainBullets: 3,
                clickable: true,
                type: "progressbar",
            },
            watchOverflow: true,
        });

        const allInstructionsLink = document.querySelector(".js-all-instructions-link");

        if (allInstructionsLink) {
            allInstructionsLink.classList.add("swiper-slide");
            swiper.appendSlide(allInstructionsLink);
        }
    }
}
